import { observable, computed, action, decorate } from 'mobx';
import { INSURANCE_GETPOLICIES, INSURANCE_GETPOLICY } from 'api';
import moment from 'moment';

class PolicyModule {
    constructor(props, appStore) {
        this.appStore = appStore;
    }

    policy = {};

    policies = [];

    message = {
        title: '',
        body: '',
    };

    isAddPolicyModal = false

    isFailAddPolicyModal = false

    isLoadingAddPolicy = false;

    errorMessage = '';

    setIsAddPolicyModal(value) {
        this.isAddPolicyModal = value;
    }

    setIsFailAddPolicyModal(value) {
        this.isFailAddPolicyModal = value;
    }

    setIsLoadingAddPolicy(value) {
        this.isLoadingAddPolicy = value;
    }

    setErrorMessage(value) {
        this.errorMessage = value;
    }

    get validPolicies() {
        return this.policies.filter((policy) => policy.status.code === 'PolicyStatus_Valid'
            || (policy.status.code === 'PolicyStatus_Invalid' && (moment().isBefore(policy.contractEndDate) || moment().isSame(policy.contractEndDate))));
    }

    get archivalPolicies() {
        return this.policies.filter((policy) => policy.status.code === 'PolicyStatus_Archival'
            || policy.status.code === 'PolicyStatus_Terminated'
            || policy.status.code === 'PolicyStatus_Completed'
            || policy.status.code === 'PolicyStatus_Annulated'
            || (policy.status.code === 'PolicyStatus_Invalid' && moment().isAfter(policy.contractEndDate)));
    }

    getPolicies() {
        return INSURANCE_GETPOLICIES()
            .then((data) => {
                const { policies } = data;
                this.policies = policies;
            }).catch(() => {
            });
    }

    getPolicy(id) {
        return INSURANCE_GETPOLICY(id)
            .then((data) => {
                const { policy, companyCode } = data;
                policy.companyCode = companyCode;
                if (policy.tabs.find((tab) => tab.title === '������ ��������')) {
                    policy.tabs.find((tab) => tab.title === '������ ��������').items.find((item) => item.title === '������ ��������').years.forEach((year) => {
                        Object.keys(year).forEach((yearKey) => {
                            Object.keys(year[yearKey].rows).forEach((rowKey) => {
                                if (year[yearKey].rows[rowKey].status === '�� �������') {
                                    year[yearKey].rows[rowKey].paymentLink = '';
                                } else {
                                    year[yearKey].rows[rowKey].paymentLink = null;
                                }
                            });
                        });
                    });
                }
                this.policy = policy;
            }).catch(() => {
            });
    }

    updatePaymentLinkLife(paymentLink, yearIndex, rowIndex) {
        if (this.policy.tabs.find((tab) => tab.title === '������ ��������')) {
            this.policy.tabs.find((tab) => tab.title === '������ ��������').items.find((item) => item.title === '������ ��������').years[0][yearIndex].rows[rowIndex].paymentLink = paymentLink;
        }
    }

    clearPolicies() {
        this.policies = [];
    }

    clearPolicy() {
        this.policy = {};
    }
}

decorate(PolicyModule, {
    policy: observable,
    policies: observable,
    isAddPolicyModal: observable,
    isFailAddPolicyModal: observable,
    isLoadingAddPolicy: observable,
    errorMessage: observable,
    setIsAddPolicyModal: action.bound,
    setIsFailAddPolicyModal: action.bound,
    setIsLoadingAddPolicy: action.bound,
    setErrorMessage: action.bound,
    validPolicies: computed,
    archivalPolicies: computed,
    message: observable,
    getPolicies: action.bound,
    getPolicy: action.bound,
    updatePaymentLinkLife: action.bound,
    clearPolicies: action.bound,
    clearPolicy: action.bound,
});

export default PolicyModule;
